import { createPatchAPI } from '@cuemath/rest-api';

import { BASE_URL } from '../constants/api';

const { usePatch: useAssignTeacherPatch } = createPatchAPI({
  getURL: studentServiceId =>
    `${BASE_URL}/lead/assign-lead-to-teacher/${studentServiceId}`,
});

export { useAssignTeacherPatch };
